import React from 'react';

import { Settings } from 'components';

export const OperatorSettingsPage: React.FC = () => <Settings />;
